const CourseBook = () => {

    // const documentUrl = "<iframe src="https://drive.google.com/file/d/1sl5dBjwYJ3Ykjh9hYqiiMsy8R3gaQU5j/preview" width="640" height="480" allow="autoplay"></iframe>"
    return (
        <div>
            <iframe src="https://drive.google.com/file/d/1sl5dBjwYJ3Ykjh9hYqiiMsy8R3gaQU5j/preview" width="100%" height="100px" />

        </div>
    );
};
export default CourseBook;